import {  Dispatch } from "redux";
import { calculateClampex, updateInputDataRequiredFields, updateInputData, updateProduct } from '../../redux/product/productActions';
import { ApplicationState} from "../../redux/state";
import { connect } from "react-redux";
import ControlButtons from './ControlButtons';
import { ProductInputData, ProductInputDataRequiredFields } from "../../redux/product/productTypes";
import { ClampexType } from "../../types/types";

const mapStateToProps =(state: ApplicationState) => ({
    clampexType: state.product.currentProduct.type,
    //productInputData: state.product.productInputData,
    productInputData: state.product.productInputData,
    currentProduct: state.product.currentProduct
});


const mapDispatchToProps = (dispatch: Dispatch) => ({
    calculate:(clampexType: ClampexType,  productInputData: ProductInputData) => dispatch(calculateClampex(clampexType, productInputData)),
    updateRequiredValue:(productInputDataRequiredFields: ProductInputDataRequiredFields) => dispatch(updateInputDataRequiredFields(productInputDataRequiredFields)),
    inputChanged:(productInputData: any) => dispatch(updateInputData(productInputData)),
    updateProduct:(product: ClampexType) => dispatch(updateProduct(product))
});

const ConnectedControlButtons = connect(
    mapStateToProps,
    mapDispatchToProps
    )(ControlButtons);

export default ConnectedControlButtons;